import { Badge } from 'components/Badge/Badge'
import { LabelBadge } from 'components/Badge/LabelBadge'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { Cell, RightCell } from 'components/HonestTable/HonestTable.styled'
import { NavBar } from 'components/NavBar/NavBar'
import { Button, ColoredDot, colors, Flex, MainHeadline, PageWrapper } from 'styling/GlobalStyles'
import { BodyText, OtherText } from 'styling/Typography'
import {
    IShiftProgramRow,
    SHIFT_PROGRAM_STATUS_COLORS,
    SHIFT_PROGRAM_STATUS_LABELS,
} from 'types/shiftPrograms.interface'
import { MOCK_SHIFT_PROGRAMS } from './shiftProgramsData'
import { useNavigate } from 'react-router-dom'

const columns: IHonestTableColumn<IShiftProgramRow>[] = [
    {
        id: 'program',
        header: 'Program',
        fill: true,
        sticky: true,
        minWidth: '16rem',
        cell: (item) => (
            <Cell>
                <BodyText weight='600'>{item.title}</BodyText>
                <OtherText grey>{item.meta}</OtherText>
            </Cell>
        ),
    },
    {
        id: 'frequency',
        header: 'Frequency',
        minWidth: '8rem',
        cell: (item) => (
            <LabelBadge color={colors.orange} backgroundColor={colors.paleOrange}>
                {item.frequency}
            </LabelBadge>
        ),
    },
    {
        id: 'lastRun',
        header: 'Last run',
        align: 'right',
        minWidth: '10rem',
        cell: (item) => (
            <RightCell>
                <OtherText grey>{item.lastRun}</OtherText>
            </RightCell>
        ),
    },
    {
        id: 'status',
        header: 'Status',
        align: 'right',
        minWidth: '8rem',
        cell: (item) => {
            const color = SHIFT_PROGRAM_STATUS_COLORS[item.status]
            return (
                <RightCell>
                    <Badge hexColor={color}>
                        <Flex gap='0.5rem' center>
                            <ColoredDot color={color} />
                            <BodyText>{SHIFT_PROGRAM_STATUS_LABELS[item.status]}</BodyText>
                        </Flex>
                    </Badge>
                </RightCell>
            )
        },
    },
]

export const ShiftPrograms = () => {

    const navigate = useNavigate()

    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between width='100%' mb='16'>
                    <MainHeadline>Shift Programs</MainHeadline>
                    <Button orange onClick={() => navigate('add')}>Add Program</Button>
                </Flex>
                <HonestTable columns={columns} data={MOCK_SHIFT_PROGRAMS} keyField='id' />
            </PageWrapper>
        </>
    )
}
